import { RSAA } from 'redux-api-middleware';
import getOwnerTypesURL from 'url-constructors/getOwnerTypesURL';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';
import { IOwnerTypesProps } from 'types/shared';

const REQUEST = 'opus/ownerTypes/REQUEST';
const SUCCESS = 'opus/ownerTypes/SUCCESS';
const FAILURE = 'opus/ownerTypes/FAILURE';

type OwnerTypesActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

interface IOwnerTypesState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: IOwnerTypesProps[];
}

interface IOwnerTypesAction {
  type: OwnerTypesActionTypes;
  payload: IOwnerTypesProps[];
}

const initialState: IOwnerTypesState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
};

function reducer(
  state: IOwnerTypesState = initialState,
  action: IOwnerTypesAction
): IOwnerTypesState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadOwnerTypes(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { ownerTypes } = getState();

    return await dispatch({
      [RSAA]: {
        bailout: ownerTypes.pending || ownerTypes.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IOwnerTypesAction,
              state: IOwnerTypesState,
              res: any
            ): Promise<any> {
              const json = await res.json();
              return json;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getOwnerTypesURL(),
      },
    });
  };
}

export { loadOwnerTypes };
export default reducer;
